import { API_URL } from '../constants'

/**
 * Downloads a CSV file from an authenticated backend endpoint and triggers the
 * browser's Save dialog. Uses the session bearer token to authenticate the
 * request, mirroring the approach used by `downloadInvoice.ts`.
 */
export default async function downloadCsv(
  endpoint: string,
  fileName: string,
  sessionToken: string
): Promise<void> {
  const url = endpoint.startsWith('http') ? endpoint : `${API_URL}${endpoint}`
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${sessionToken}` },
  })

  if (!res.ok) {
    throw new Error(`Failed to download CSV: ${res.statusText}`)
  }

  const blob = await res.blob()
  const blobUrl = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = blobUrl
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.parentNode?.removeChild(link)
  window.URL.revokeObjectURL(blobUrl)
}
